import { render, staticRenderFns } from "./ApiLogs.vue?vue&type=template&id=f8f31d56&scoped=true"
import script from "./ApiLogs.vue?vue&type=script&lang=js"
export * from "./ApiLogs.vue?vue&type=script&lang=js"
import style0 from "./ApiLogs.vue?vue&type=style&index=0&id=f8f31d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f31d56",
  null
  
)

export default component.exports